import React from 'react';
import {
  Stepper as MaterialStepper,
  Step,
  StepLabel,
  StepConnector,
  withStyles,
} from '@material-ui/core';
import { StepperProps } from './stepper-props';
import { StepIcone } from './componentes';
import { useStyles } from './stepper-styles';

const Connector = withStyles((theme) => ({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      background: theme.palette.primary.light,
    },
  },
  completed: {
    '& $line': {
      background: theme.palette.primary.main,
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
}))(StepConnector);

export function Stepper({ steps, stepAtual }: StepperProps) {
  const classes = useStyles();
  return (
    <MaterialStepper
      
      alternativeLabel
      activeStep={stepAtual || 0}
      className={classes.stepper}
      connector={<Connector />}
    >
      {steps.map((step, index) => (
        <Step key={index}>
          <StepLabel StepIconComponent={(props) => <StepIcone {...props} icon={step.icone} />}>
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </MaterialStepper>
  );
}
